export const rating_select_values = ['0', '7', '12', '16', '18'];
